import { render, staticRenderFns } from "./PropertyFormNotes.vue?vue&type=template&id=769fac4a&scoped=true&"
import script from "./PropertyFormNotes.vue?vue&type=script&lang=js&"
export * from "./PropertyFormNotes.vue?vue&type=script&lang=js&"
import style0 from "./PropertyFormNotes.vue?vue&type=style&index=0&id=769fac4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769fac4a",
  null
  
)

export default component.exports